import { render } from "./Specials.vue?vue&type=template&id=25ae15fc&scoped=true"
import script from "./Specials.vue?vue&type=script&lang=js"
export * from "./Specials.vue?vue&type=script&lang=js"

import "./Specials.vue?vue&type=style&index=0&id=25ae15fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ae15fc"]])

export default __exports__